<template>
  <v-card elevation="0" class="pa-2">
    <!-- راهنما -->
    <v-alert
      color="info"
      border="left"
      type="info"
      text
      colored-border
      icon="mdi-information-outline"
      class="text-right"
    >
      <ul style="list-style-type: disc; margin-right: 20px; line-height: 1.5;">
        <li>
          <strong>تمدید و ارتقا:</strong> برای تمدید فرصت بهره‌گیری یا ارتقا اعتبار، ابتدا <strong>فیلتر نوع کیوآر</strong> را روی یک نوع خاص تنظیم کرده و سپس ردیف‌ها را انتخاب کنید.
        </li>
        <li>
          <strong>انتقال:</strong> تنها کیوآرکدهایی که در وضعیت <strong>«قابل استفاده»</strong> هستند، قابلیت انتقال را دارند.
        </li>
        <li>
          <strong>زمان تولید:</strong> تصویر کیوآرکدهای جدید، معمولاً <strong>۱ الی ۲ دقیقه</strong> پس از ساخت، تولید شده و در این لیست نمایش داده می‌شوند.
        </li>
      </ul>
    </v-alert>

    <!-- هدر دکمه‌های عملیاتی سراسری -->
    <v-row class="mb-4 d-flex align-center">
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-btn
          block
          class="btn-edit rounded-lg"
          :disabled="selectedItemsComputed.length === 0"
          @click="openTransferDialog(selectedItemsComputed)"
        >
          <v-icon class="ml-1" right>mdi-account-arrow-right</v-icon> 
          انتقال خرید ({{ selectedItemsComputed.length }})
        </v-btn>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-btn
          block
          class="btn-buy rounded-lg"
          :disabled="selectedItemsComputed.length === 0"
          @click="openTransferUserDialog(selectedItemsComputed)"
        >
          <v-icon class="ml-1" right>mdi-account-arrow-left</v-icon> 
          انتقال پیش‌خرید ({{ selectedItemsComputed.length }})
        </v-btn>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-btn
          block
          class="btn-download rounded-lg"
          @click="exportData()"
          :loading="loadingExport"
        >
          <v-icon class="ml-1" right>mdi-download</v-icon> دانلود ({{ selectedItems.length > 0 ? selectedItems.length : 'همه' }})
        </v-btn>
      </v-col>

      <v-col cols="12" sm="6" md="6" lg="3">
        <v-btn
          block
          class="btn-show rounded-lg"
          :disabled="selectedItemschangestatus.length === 0"
          @click="dialogs.changestatus = true"
        >
          <v-icon class="ml-1" right>mdi-clock</v-icon> تمدید فرصت بهره‌گیری ({{ selectedItemschangestatus.length }})
        </v-btn>
      </v-col>

      <v-col cols="12" sm="6" md="6" lg="3">
        <v-btn
          block
          class="btn-show rounded-lg"
          :disabled="selectedItemsupgrade_validity.length === 0"
          @click="dialogs.changevalidity = true"
        >
          <v-icon class="ml-1" right>mdi-clock</v-icon> ارتقا اعتبار اولیه ({{ selectedItemsupgrade_validity.length }})
        </v-btn>
      </v-col>
    </v-row>

    <!-- فیلترها و دکمه تاگل نحوه نمایش -->
    <v-card outlined class="pa-3 mb-4 rounded-lg">
      <v-row align="center" no-gutters>
        <v-col class="pa-2" cols="12" lg="2" md="3">
          <v-select
            v-model="tableProps.length"
            :items="perPageOptions"
            class="rounded-lg"
            dense
            hide-details
            label="تعداد پوشه در صفحه"
            outlined
            @change="onPerPageChange"
          />
        </v-col>
        <v-col class="pa-2" cols="12" lg="3" md="3">
          <v-text-field
            v-model="tableProps.search"
            append-icon="mdi-magnify"
            class="rounded-lg"
            clearable
            dense
            hide-details
            :label="$t('qrUsersList.search') || 'جستجو'"
            outlined
            @keyup.enter="onSearch"
            @click:clear="onSearch"
          />
        </v-col>
        <v-col class="pa-2" cols="12" lg="2" md="2">
          <v-autocomplete
            v-model="tableProps.dir"
            class="rounded-lg"
            clearable
            :items="dirItems"
            item-text="text"
            item-value="value"
            dense
            hide-details
            label="جهت مرتب سازی"
            outlined
            @change="onFilterChange('dir', $event)"
          >
            <template v-slot:selection="{ item }">
              <v-icon left small>{{ item.icon }}</v-icon>
              <span>{{ item.text }}</span>
            </template>
            <template v-slot:item="{ item }">
              <v-icon left small>{{ item.icon }}</v-icon>
              <span>{{ item.text }}</span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="pa-2" cols="12" lg="2" md="2">
          <v-autocomplete
            v-model="tableProps.status"
            append-icon="mdi-list-status"
            class="rounded-lg"
            clearable
            :items="statusItems"
            item-text="text"
            item-value="value"
            dense
            :no-data-text="$t('qrUsersList.noStatus') || 'وضعیتی یافت نشد'"
            hide-details
            :label="$t('qrUsersList.usersColumns.status') || 'وضعیت'"
            outlined
            @change="onFilterChange('status', $event)"
          >
            <template v-slot:selection="{ item }">
              <v-icon left small color="primary">{{ item.icon }}</v-icon>
              {{ item.text }}
            </template>
            <template v-slot:item="{ item }">
              <v-icon left small color="primary">{{ item.icon }}</v-icon>
              {{ item.text }}
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="pa-2" cols="12" lg="2" md="2">
          <qr-type-filter v-model="tableProps.type" @input="onFilterChange('type', $event)" />
        </v-col>

        <!-- دکمه تاگل نحوه نمایش -->
        <v-col class="pa-2 d-flex justify-end" cols="12" lg="1" md="12">
          <v-btn-toggle v-model="viewMode" mandatory dense class="rounded-lg border">
            <v-btn value="accordion" small icon title="نمای آکاردئونی">
              <v-icon small>mdi-view-headline</v-icon>
            </v-btn>
            <v-btn value="folder" small icon title="نمای پوشه‌ای">
              <v-icon small>mdi-folder-table</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </v-card>

    <!-- اسپینر لودینگ کل صفحه -->
    <v-row v-if="loading" justify="center" class="my-8">
      <atom-spinner :animation-duration="1500" :size="70" color="var(--v-primary-base)" />
    </v-row>

    <!-- محتوا در صورت وجود داده -->
    <template v-else-if="groupedPurchases.length > 0">

      <!-- ================= ۱. نمای پوشه‌ای (Folder View) ================= -->
      <div v-if="viewMode === 'folder'">
        <div v-if="!activeFolderGroup">
          <v-row class="align-stretch">
            <v-col
              v-for="group in groupedPurchases"
              :key="group.folder_name || group.key || group.id"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="d-flex"
            >
              <folder-card
                :group="group"
                :folder-name="getFolderName(group)"
                :is-downloading="downloadingGroupKey === group.key"
                @open="openFolder"
                @edit-name="startEditFolderName"
                @transfer-group="openTransferDialog"
                @transfer-user-group="openTransferUserDialog"
                @export-group="exportData(($event.items || []).map(i => i.id), $event.key)"
              />
            </v-col>
          </v-row>
        </div>

         <!-- داخل یک پوشه انتخابی -->
<div v-else>
  <div class="d-flex align-center justify-space-between mb-3 flex-wrap" style="gap: 8px;">
    <v-btn text color="primary" class="rounded-pill" @click="activeFolderGroup = null">
      <v-icon right>mdi-arrow-right</v-icon>
      بازگشت به لیست پوشه‌ها
    </v-btn>

    <div class="d-flex align-center" style="gap: 4px">
      <span class="font-weight-bold">{{ getFolderName(activeFolderGroup) }}</span>
      <v-chip small color="primary lighten-5" text-color="primary">
        {{ activeFolderGroup.total_items || (activeFolderItems.data ? activeFolderItems.data.length : (activeFolderGroup.items || []).length) }} عدد کیوآر
      </v-chip>
    </div>

    <!-- دکمه‌های عملیاتی داخل پوشه -->
    <div class="d-flex align-center flex-wrap" style="gap: 6px;">
      <v-btn
        small
        class="btn-edit rounded-lg"
        :disabled="activeGroupAvailableItems.length === 0"
        @click="openTransferDialog(activeGroupAvailableItems)"
      >
        <v-icon small right class="mx-1">mdi-account-arrow-right</v-icon>
        انتقال خرید کل پوشه
      </v-btn>

      <v-btn
        small
        class="btn-buy rounded-lg"
        :disabled="activeGroupAvailableItems.length === 0"
        @click="openTransferUserDialog(activeGroupAvailableItems)"
      >
        <v-icon small right class="mx-1">mdi-account-arrow-left</v-icon>
        انتقال پیش‌خرید کل پوشه
      </v-btn>

      <v-btn
        small
        class="btn-get-code rounded-lg"
        :loading="downloadingGroupKey === activeFolderGroup.key"
        @click="exportData((activeFolderGroup.items || []).map(i => i.id), activeFolderGroup.key)"
      >
        <v-icon small class="px-1">mdi-folder-download</v-icon>
        دانلود کامل
      </v-btn>
    </div>
  </div>

  <!-- جدول کیوآرها دقیقاً مشابه آکاردئون -->
  <v-card outlined class="rounded-lg overflow-hidden">
    <vue-table
      :headers="headers"
      :data="activeFolderItems"
      :loading="folderLoadings[activeFolderGroup.folder_name || activeFolderGroup.key]"
      dense
      :item-class="getRowClass"
      :value="selectedItems"
      show-select
      no-data-text="موردی در این پوشه یافت نشد."
      @input="selectedItems = $event"
      @change="onFolderTableFetch"
    >
      <!-- محاسبه صحیح شماره ردیف بر اساس صفحه جاری -->
      <template v-slot:index="{ item, index }">
        {{ getRowIndex(item, index) }}
      </template>
      
        <template v-slot:data-table-select="{ item, isSelected, select }">
          <v-simple-checkbox
            v-if="isItemSelectable(item)"
            :value="isSelected"
            color="primary"
            @input="select($event)"
          />  
          <v-icon v-else small color="grey lighten-1">
            mdi-minus
          </v-icon>
        </template>
      
      <template v-slot:image="{ item }">
        <v-avatar :size="$vuetify.breakpoint.smAndDown ? 70 : 80" rounded class="my-1 grey lighten-4">
          <v-img :src="item.image" contain>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0 flex-column text-center px-1" align="center" justify="center">
                <v-icon color="grey" class="mb-1">mdi-image-off-outline</v-icon>
                <span class="text-caption grey--text" style="font-size: 10px !important;">در حال تولید</span>
              </v-row>
            </template>
          </v-img>
        </v-avatar>
      </template>
      
      <template v-slot:expire_days="{ item }">
        <v-chip class="pa-2 rounded-pill" outlined small :color="getOpportunity(item.created_at).color">
          {{ getOpportunity(item.created_at).text }}
        </v-chip>
      </template>
      
      <template v-slot:identifier="{ item }">
        <v-chip class="px-2 py-3 rounded-lg custom-link-chip">
          <v-icon left small :color="item.status === 'transferred' ? '#042FC8' : 'grey'">
            {{ item.status === 'transferred' ? 'mdi-link-variant' : 'mdi-identifier' }}
          </v-icon>
          <template v-if="item.status === 'transferred'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <a
                  :href="`https://qrland.in/${item.identifier}`"
                  target="_blank"
                  class="d-inline-block text-truncate text-decoration-none"
                  style="max-width: 140px; color: #042FC8; font-weight: bold;"
                  dir="ltr"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop
                >
                  qrland.in/{{ item.identifier }}
                </a>
              </template>
              <span>https://qrland.in/{{ item.identifier }}</span>
            </v-tooltip>
            <v-btn icon small @click.stop="copyids(`https://qrland.in/${item.identifier}`)" color="#042FC8" class="mr-1">
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <span class="font-weight-bold" style="color: #555;">{{ item.identifier }}</span>
          </template>
        </v-chip>
      </template>
      
      <template v-slot:status="{ item }">
        <v-chip small :color="item.status === 'error' ? 'mdi-cancel':item.status === 'transferred' ? 'success' : item.status === 'available' ? 'info' : 'error'">
          <v-icon small class="pr-1">
            {{ item.status === 'deleted' ? 'mdi-cancel': item.status === 'transferred' ? 'mdi-account-arrow-right' : item.status === 'available' ? 'mdi-check' : 'mdi-clock' }}
          </v-icon>
          {{ item.status === 'deleted' ? 'حذف شده' : item.status === 'transferred' ? 'منتقل شده' : item.status === 'available' ? 'قابل استفاده' : 'منقضی شده' }}
        </v-chip>
      </template>
      
      <template v-slot:short_code="{ item }">
        <div class="d-flex flex-column text-right py-1">
          <span class="caption">
            <v-icon small color="primary" class="ml-1">mdi-{{ (getQrTypes(item.type) || {}).icon || 'qrcode' }}</v-icon>
            {{ (getQrTypes(item.type) || {}).name }}
          </span>
          <span class="font-weight-bold text-body-2">{{ item.title }}</span>
        </div>
      </template>
      
      <template v-slot:action="{ item }" >
        <action-buttons :data="item" :meta="getMetaButtons(item)" v-if="item.status !== 'deleted'"/>
      </template>
    </vue-table>
  </v-card>
</div>

        </div>

      <!-- ================= ۲. نمای آکاردئونی (Accordion View) ================= -->
      <div v-else-if="viewMode === 'accordion'">
        <v-expansion-panels multiple hover class="rounded-lg" @change="onAccordionChange">
          <accordion-group
            v-for="group in groupedPurchases"
            :key="group.key"
            :group="group"
            :folder-title="getFolderName(group)"
            :is-editing="editingFolderKey === group.key"
            :is-downloading="downloadingGroupKey === group.key"
            :loading-items="folderLoadings[group.key]"
            :selected-items="selectedItems"
            :headers="headers"
            :get-opportunity="getOpportunity"
            :meta-buttons="getMetaButtons"
            @change-folder-page="handleFolderPageChange"
            @update:title="$set(groupTitles, group.key, $event)"
            @start-edit="startEditFolderName(group)"
            @save-title="saveFolderName(group, $event || groupTitles[group.key])"
            @transfer-group="openTransferDialog"
            @transfer-user-group="openTransferUserDialog"
            @export-items="exportData($event, group.key)"
            @export-group="exportData(($event.items || []).map(i => i.id), group.key)"
            @update:selectedItems="selectedItems = $event"
            @copy-id="copyids"
          />
        </v-expansion-panels>
      </div>

      <!-- ================= نوار صفحه‌بندی پوشه‌ها ================= -->
      <v-card
        v-if="!activeFolderGroup && totalItems > 0"
        outlined
        class="mt-4 pa-3 rounded-lg d-flex flex-wrap align-center justify-space-between"
        style="gap: 12px"
      >
        <div class="caption grey--text text--darken-2">
          نمایش <strong>{{ paginationFrom }}</strong> تا <strong>{{ paginationTo }}</strong> از مجموع <strong>{{ totalItems }}</strong> پوشه
        </div>

        <v-pagination
          v-if="pageCount > 1"
          v-model="tableProps.page"
          :length="pageCount"
          :total-visible="7"
          circle
          color="primary"
          @input="onPageChange"
        />
      </v-card>
    </template>

    <v-card v-else class="pa-8 text-center" outlined>
      <v-icon size="48" color="grey lighten-1">mdi-folder-open-outline</v-icon>
      <div class="text-subtitle-1 grey--text mt-2">هیچ پیش‌خریدی یافت نشد.</div>
    </v-card>

    <!-- دیالوگ‌های سیستم -->
    <buy-package-dialog v-model="dialogs.buy" :qr-types="qrTypes" @success="fetchList" />
    <bulk-create-dialog v-model="dialogs.bulk" :qr-types="qrTypes" @success="fetchList" />

    <!-- دیالوگ انتقال -->
    <custom-popup 
      maxWidth="900px" 
      v-model="dialogs.transfer" 
      :cons="{ title: isTransferToUser ? 'انتقال به پیش‌خرید کاربر' : 'انتقال به کاربر دیگر' }"
    >
      <div class="pa-4 text-center">
        <p v-if="transferTarget.mode === 'folder'" class="mb-4">
          شما در حال انتقال کل پوشه <b>«{{ transferTarget.folder_name }}»</b>
          <span v-if="transferTarget.count"> (شامل {{ transferTarget.count }} آیتم)</span> هستید.
        </p>
        <p v-else class="mb-4">
          تعداد <b>{{ transferTarget.ids.length }}</b> آیتم برای انتقال انتخاب شده است.
        </p>

        <!-- فیلد شماره موبایل -->
        <div class="mt-4">
          <vue-tel-input
            v-model="transferForm.phone"
            :default-country="defaultCountry"
            :preferred-countries="['IR', 'IQ', 'US', 'CA', 'GB', 'AE']"
            placeholder="شماره موبایل کاربر مقصد"
            class="rounded-lg phone-input text-left"
            @input="onPhoneInput"
            @validate="onPhoneValidate"
            @keydown.enter="handleTransferSubmit"
          />
          <div v-if="!phoneValidated.valid && transferForm.phone" class="error--text text-caption mt-1 text-right">
            شماره موبایل نامعتبر است
          </div>
        </div>
        <v-btn
          block
          :class="isTransferToUser ? 'btn-buy' : 'btn-edit'"
          class="rounded-lg mt-4"
          @click="handleTransferSubmit"
          :loading="btnLoading"
          :disabled="!phoneValidated.valid"
        >
          {{ isTransferToUser ? 'انتقال پیش‌خرید' : 'انتقال خرید' }}
        </v-btn>
      </div>
    </custom-popup>

    <!-- جزئیات انتقال -->
    <custom-popup maxWidth="550px" v-model="dialogs.info" :cons="{ title: 'جزئیات انتقال' }">
      <v-card v-if="infoLoading" class="d-flex align-center justify-center" flat height="300">
        <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="var(--v-primary-base)" />
      </v-card>
      <div class="pa-5" v-else-if="transferInfoData">
        <div class="text-center mb-6">
          <p class="text-body-2 grey--text mb-0">شناسه: {{ transferInfoData.identifier }}</p>
        </div>
        <v-divider class="mb-6"></v-divider>
        <v-row>
          <v-col cols="12" sm="6">
            <div class="d-flex align-center mb-2">
              <v-avatar color="blue lighten-5" size="32" class="ml-3">
                <v-icon color="blue" size="22">mdi-account-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-caption grey--text mb-1">انتقال گیرنده</div>
                <div class="font-weight-bold text-body-2">
                  {{ transferInfoData.transfer_user.name || '' }} {{ transferInfoData.transfer_user.lastName || '' }}
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="d-flex align-center mb-2">
              <v-avatar color="green lighten-5" size="42" class="ml-3">
                <v-icon color="green" size="22">mdi-phone-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-caption grey--text mb-1">شماره تماس</div>
                <div class="font-weight-bold text-body-2" dir="ltr">
                  +{{ transferInfoData.transfer_user.phone }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </custom-popup>

    <bulk-renewal-dialog
      v-model="dialogs.changevalidity"
      :selected-items="selectedItemsupgrade_validity"
      :qr-types="qrTypes"
      @success="fetchList(); selectedItems = []"
    />
    <bulk-renewal-dialog
      v-model="dialogs.changestatus"
      :selected-items="selectedItemschangestatus"
      :qr-types="qrTypes"
      @success="fetchList(); selectedItems = []"
    />
  <models-gallery
  v-model="galleryDialog"
  :type="currentTransferItem ? currentTransferItem.type : ''"
  :is-transfer-mode="true"
  @select-template="handleCreateQr"
  @close="cancelTransferWorkflow"
/>
  </v-card>
</template>

<script>
import BuyPackageDialog from './BuyPackageDialog.vue';
import BulkCreateDialog from './BulkCreateDialog.vue';
import { AtomSpinner } from 'epic-spinners';
import BulkRenewalDialog from './BulkRenewalDialog.vue';
import QrTypeFilter from './QrTypeFilter.vue';
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";
import FolderCard from './FolderCard.vue';
import AccordionGroup from './AccordionGroup.vue';
import QrTypeCard from './QrTypeCard.vue';
import modelsGallery from './modelsGallery.vue';

export default {
  name: "PrePurchaseList",
  components: {
    BuyPackageDialog,
    BulkCreateDialog,
    AtomSpinner,
    QrTypeFilter,
    ActionButtons,
    BulkRenewalDialog,
    FolderCard,
    AccordionGroup,
    QrTypeCard,
    modelsGallery
  },
  data() {
    return {
       isCreatingQr: false, 
      viewMode: "accordion",
      activeFolderGroup: null,
      perPageOptions: [10, 25, 50, 100],
      dirItems: [
        { text: "صعودی", value: "asc", icon: "mdi-sort-ascending" },
        { text: "نزولی", value: "desc", icon: "mdi-sort-descending" },
      ],
      loading: false,
      btnLoading: false,
      loadingExport: false,
      downloadingGroupKey: null,
      editingFolderKey: null,
      groupTitles: {},
      itemsToTransfer: [],
      folderItemsMap: {},
      folderLoadings: {},
      isTransferToUser: false,

      statusItems: [
        { text: 'همه', value: null, icon: "mdi-filter" },
        { text: 'قابل استفاده', value: "available", icon: "mdi-check" },
        { text: 'منقضی شده', value: "pending", icon: "mdi-clock" },
        { text: 'منتقل شده', value: "transferred", icon: "mdi-account-arrow-right" },
        { text: 'خذف شده', value:'deleted', icon:'mdi-cancel'}
      ],
      selectedItems: [],
      infoLoading: false,
      headers: [
        { value: "index", text: "ردیف", sortable: false, align: "center", width: "60px" },
        { value: "image", text: "تصویر", sortable: false, align: "center", width: "90px" },
        { value: "short_code", text: "عنوان و نوع", sortable: false, align: "right" },
        { value: "identifier", text: "شناسه", sortable: false, align: "center" },
        { value: "status", text: "وضعیت", sortable: false, align: "center" },
        { value: "created_at_diff", text: "زمان ایجاد", sortable: false, align: "center" },
        { value: "expire_days", text: "فرصت بهره‌گیری", sortable: false, align: "center" },
        { value: "action", text: "عملیات", sortable: false, align: "center", width: "120px" },
      ],


      transactionData: {
        data: [],
        total: 0,
        current_page: 1,
        last_page: 1,
        from: 0,
        to: 0,
        per_page: 50,
      },

      tableProps: {
        search: "",
        length: 50,
        column: "created_at",
        dir: "desc",
        page: 1,
        type: "all",
        status: 'all',
      },

      dialogs: {
        buy: false,
        bulk: false,
        transfer: false,
        info: false,
        changestatus: false,
        changevalidity: false,
      },
      galleryDialog: false,
      transferQueue: [], 
      currentTransferTargetId: null,
      qrTypes: [],
      transferForm: { phone: "" },
      phoneValidated: { valid: false, number: "", country: null },
      transferInfoData: null,
      transferTarget: {
        mode: "ids",
        ids: [],
        folder_name: null,
        type: null,
        count: 0,
      },
    };
  },

  computed: {
    currentTransferItem() {
      return this.transferQueue.length > 0 ? this.transferQueue[0] : null;
    },
    activeFolderItems() {
      if (!this.activeFolderGroup) return [];
      const folderKey = this.activeFolderGroup.key || this.activeFolderGroup.folder_name;
      return this.folderItemsMap[folderKey] || this.activeFolderGroup.items || [];
    },
    totalItems() {
      return this.transactionData?.total ?? this.transactionData?.meta?.total ?? (this.transactionData?.data?.length || 0);
    },
    pageCount() {
      if (this.transactionData?.last_page) return this.transactionData.last_page;
      if (this.transactionData?.meta?.last_page) return this.transactionData.meta.last_page;
      return Math.ceil(this.totalItems / this.tableProps.length) || 1;
    },
    paginationFrom() {
      if (this.transactionData?.from !== undefined && this.transactionData?.from !== null) {
        return this.transactionData.from;
      }
      return this.totalItems > 0 ? ((this.tableProps.page - 1) * this.tableProps.length) + 1 : 0;
    },
    paginationTo() {
      if (this.transactionData?.to !== undefined && this.transactionData?.to !== null) {
        return this.transactionData.to;
      }
      const to = this.tableProps.page * this.tableProps.length;
      return to > this.totalItems ? this.totalItems : to;
    },
    groupedPurchases() {
      const rawList = this.transactionData?.data || (Array.isArray(this.transactionData) ? this.transactionData : []);
      if (!Array.isArray(rawList) || rawList.length === 0) return [];

      return rawList.map((item) => {
        const folderName = typeof item === 'string' ? item : (item.folder_name || item.name || item.key);
        return {
          key: folderName,
          folder_name: folderName,
          total_items: item.total_items || item.items_count || item.total || 0,
          created_at: item.created_at || null,
          items: this.folderItemsMap[folderName] || null
        };
      });
    },
      activeGroupAvailableItems() {
      const items = Array.isArray(this.activeFolderGroup?.items)
        ? this.activeFolderGroup.items
        : (this.activeFolderGroup?.items?.data || []);
      return items.filter(item => item.status === "available");
    },
    selectedItemschangestatus() {
      return this.selectedItems.filter(item => item.status === 'pending' || item.status === 'available');
    },
    selectedItemsupgrade_validity() {
      return this.selectedItems.filter(item => item.status === 'transferred');
    },
    selectedItemsComputed() {
      return this.selectedItems.filter(item => item.status === 'available');
    },
    defaultCountry() {
      switch (this.$i18n.locale) {
        case "fa": return "IR";
        case "ar": return "IQ";
        case "en": return "US";
        default: return "IR";
      }
    },
  },

  mounted() {
    this.qrTypes = typeof this.getQrTypes === 'function' ? this.getQrTypes() : [];
    this.fetchList();
  },

  methods: {
isItemSelectable(item) {
    const nonSelectable = ['deleted', 'transferred', 'حذف شده', 'منتقل شده'];
    return !nonSelectable.includes(item.status);
  },

  getRowClass(item) {
    return !this.isItemSelectable(item) ? 'row-hide-checkbox' : '';
  },
    onFolderTableFetch(props) {
          if (!this.activeFolderGroup) return;
          const folderName = this.activeFolderGroup.folder_name || this.activeFolderGroup.key;
          const page = props?.page || 1;
          const length = props?.length || 10;
          this.fetcDataInFolder(folderName, page, length);
      },
    getRowIndex(item, index) {
      const dataObj = this.activeFolderItems;
      const currentPage = dataObj?.current_page || 1;
      const perPage = dataObj?.per_page || 10;
      
      if (typeof index === 'number') {
        return ((currentPage - 1) * perPage) + index + 1;
      }
      
      const itemsList = Array.isArray(dataObj) ? dataObj : (dataObj?.data || []);
      const itemIndex = itemsList.findIndex(d => d.id === item.id);
      return ((currentPage - 1) * perPage) + (itemIndex >= 0 ? itemIndex : 0) + 1;
    },
    handleFolderPageChange({ folder_name, props }) {
      if (!folder_name) return;
      const targetPage = props?.page || 1;
      const targetLength = props?.length || 10;      
      this.fetcDataInFolder(folder_name, targetPage, targetLength);
    },
    handleTransferTypeSelected(selectedValue) {
      const typeKey = typeof selectedValue === 'object' ? (selectedValue.type || selectedValue.name || selectedValue.key) : selectedValue;
      this.$set(this.transferTarget, 'type', typeKey);
    },

    setupTransferTarget(target) {
      if (target && !Array.isArray(target) && (target.folder_name || target.key || target.name)) {
        const detectedType = 
          target.type || 
          target.qr_type || 
          (Array.isArray(target.items) && target.items[0]?.type) || 
          null;

        this.transferTarget = {
          mode: "folder",
          folder_name: target.folder_name || target.key || target.name,
          ids: [],
          type: detectedType,
          count: target.total_items ?? target.total ?? (target.items?.length || 0),
        };
      } 
      else if (Array.isArray(target) && target.length > 0) {
        const firstItem = target[0];
        const detectedType = typeof firstItem === 'object' ? firstItem.type : null;

        this.transferTarget = {
          mode: "ids",
          ids: target.map(i => (typeof i === 'object' ? i.id : i)),
          folder_name: null,
          type: detectedType, 
          count: target.length,
        };
      }
    },

    openTransferDialog(target) {
      this.isTransferToUser = false;
      this.setupTransferTarget(target);
      this.dialogs.transfer = true;
    },

    openTransferUserDialog(target) {
      this.isTransferToUser = true;
      this.setupTransferTarget(target);
      this.dialogs.transfer = true;
    },
    cancelTransferWorkflow() {
      if (this.transferQueue.length > 0) {
        this.$toast.warning('فرآیند انتخاب قالب برای کیوآرکدهای باقیمانده متوقف شد.');
        this.transferQueue = []; 
      }
    },
       processNextInQueue() {
      if (this.transferQueue.length > 0) {
        this.galleryDialog = true;
      } else {
        this.galleryDialog = false;
        this.$toast.success('فرآیند انتقال و ساخت تمامی کیوآرکدها با موفقیت به پایان رسید.');
      }
    },
     async handleCreateQr(templatePayload) {
        if (this.isCreatingQr) return; 
      const currentItem = this.currentTransferItem;
      if (!currentItem) return;
      this.isCreatingQr = true; 

      try {
        const payload = {
          user_id: this.currentTransferTargetId,
          type: currentItem.type,
          ids: currentItem.ids,
          data: templatePayload.data, 
        };

        await this.$api.post('v1/pre_purchase/transfer/create-qr', payload);
        
        this.$toast.success(`قالب ${currentItem.type} با موفقیت اعمال شد.`);
        
        this.transferQueue.shift();
        
        this.processNextInQueue();

      } catch (error) {
        this.$toast.error(`خطا در ایجاد کیوآرکد برای نوع ${currentItem.type}`);
        console.error(error);
      }
    },
    handleTransferSubmit() {
      if (!this.phoneValidated.valid) {
        return this.$modal.error("خطا", "شماره تماس معتبر الزامی است.");
      }
      this.btnLoading = true;

      const payload = {
        phone: this.cleanPhone(this.phoneValidated.number),
      };

      if (this.transferTarget.mode === "folder") {
        payload.folder_name = this.transferTarget.folder_name;
      } else {
        payload.ids = this.transferTarget.ids;
      }

      const endpoint = this.isTransferToUser
        ? "v1/pre_purchase/transfer/toUser"
        : "v1/pre_purchase/transfer";

      this.$api
        .post(endpoint, payload)
        .then(({ data }) => {
            this.dialogs.transfer = false;
            this.selectedItems = [];
            this.transferForm.phone = "";
            this.transferTarget.type = null;
            this.fetchList();
            if (this.activeFolderGroup) {
              this.fetcDataInFolder(this.activeFolderGroup.key);
            }
            const responseData = data.data || {}; 
            console.log(data.data,"data.data")
            const targetUserId = responseData.target_user_id;
            const items = responseData.items || [];
            
            const pendingItems = items;
            console.log(items,pendingItems,"pendingItems")

            if (responseData.pending_count === 0) {
              this.$modal.success(
                "موفق",
                this.isTransferToUser
                  ? "انتقال به پیش‌خرید با موفقیت انجام شد."
                  : "انتقال با موفقیت انجام شد."
              );
            } else if(!this.isTransferToUser){
              this.$toast.info("انتقال اولیه انجام شد، لطفاً قالب‌های مورد نیاز را انتخاب کنید.");
              this.currentTransferTargetId = targetUserId;
              this.transferQueue = pendingItems;
              setTimeout(() => {
              this.processNextInQueue();
            }, 350);

          }
          })
        .catch(({ response }) => {
          this.$modal.error("خطا", response?.data?.message || "مشکلی در فرآیند انتقال پیش آمد.");
        })
        .finally(() => {
          this.btnLoading = false;
          this.isCreatingQr = false; 
        });
    },
openFolder(group) {
  this.activeFolderGroup = group;
  const folderName = group.folder_name || group.key;
  if (folderName && !this.folderItemsMap[folderName]) {
    this.fetcDataInFolder(folderName, 1, 10);
  }
},
    onAccordionChange(openedIndexes) {
      if (!Array.isArray(openedIndexes)) openedIndexes = [openedIndexes];
      openedIndexes.forEach((idx) => {
        const group = this.groupedPurchases[idx];
        if (group && group.folder_name && (!this.folderItemsMap[group.folder_name] || this.folderItemsMap[group.folder_name].length === 0)) {
          this.fetcDataInFolder(group.folder_name);
        }
      });
    },
    onPageChange(page) {
      this.tableProps.page = page;
      this.activeFolderGroup = null;
      this.fetchList();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    onPerPageChange() {
      this.tableProps.page = 1;
      this.activeFolderGroup = null;
      this.fetchList();
    },
    onSearch() {
      this.tableProps.page = 1;
      this.activeFolderGroup = null;
      this.fetchList();
    },
    onFilterChange(filter, value) {
      this.tableProps[filter] = value === "" ? null : value;
      this.tableProps.page = 1;
      this.activeFolderGroup = null;
      this.fetchList();
    },
    getFolderName(group) {
      if (!group) return "";
      return this.groupTitles[group.key] || group.folder_name || `خرید مورخ ${group.dateText || ''}`;
    },
    startEditFolderName(group) {
      const currentTitle = this.getFolderName(group);
      if (!this.groupTitles[group.key]) {
        this.$set(this.groupTitles, group.key, currentTitle);
      }
      this.editingFolderKey = group.key;
    },

    async saveFolderName(group, newName) {
      if (!newName || !group) {
        this.editingFolderKey = null;
        return;
      }

      try {
        const payload = {
          old_folder_name: group.folder_name || group.key,
          new_folder_name: newName,
        };

        await this.$api.put('v1/pre_purchase/update-folder', payload);
        this.$set(this.groupTitles, group.key, newName);
        this.$toast.success('نام پوشه با موفقیت به‌روزرسانی شد');
        this.editingFolderKey = null;
        this.fetchList();
      } catch (error) {
        this.$toast.error(error?.response?.data?.message || 'خطا در تغییر نام پوشه');
      }
    },

    getOpportunity(createdAt) {
      if (!createdAt) return { expired: false, text: "-", color: "grey" };
      const createdDate = new Date(createdAt);
      const expiryDate = new Date(createdDate.getTime() + (365 * 24 * 60 * 60 * 1000));
      const now = new Date();
      const diffTime = expiryDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays >= 0) {
        return { expired: false, text: ` ${this.persian ? this.persian(diffDays) : diffDays} روز باقی مانده`, color: "green darken-1" };
      }
      return { expired: true, text: `منقضی شده (${this.persian ? this.persian(Math.abs(diffDays)) : Math.abs(diffDays)} روز گذشته)`, color: "red darken-2" };
    },

    getMetaButtons(item) {
      let buttons = [
        { name: "download", label: "دانلود", icon: "download", class: "btn-download rounded-pill", action: this.actions }
      ];
      if (item.status !== 'transferred' && item.status !== 'deleted') {
        buttons.push({ name: "extend", label: "تمدید بهره گیری", icon: "clock", class: "btn-show rounded-pill", action: this.actions });
      }
      if (item.status === 'available') {
        buttons.push({ name: "transfer", label: "انتقال خرید", icon: "account-arrow-right", class: "btn-edit rounded-pill", action: this.actions });
        buttons.push({ name: "transfer_user", label: "انتقال پیش‌خرید", icon: "account-arrow-left", class: "btn-buy rounded-pill", action: this.actions });
      }
      if (item.status === 'transferred') {
        buttons.push({ name: "receiver_info", label: "اطلاعات گیرنده", icon: "information", class: "btn-exit rounded-pill", action: this.actions });
      }
      return { buttons };
    },

    actions(data, type) {
      if (type === "download") this.exportData([data.id]);
      else if (type === "transfer") this.openTransferDialog([data]);
      else if (type === "transfer_user") this.openTransferUserDialog([data]);
      else if (type === "extend") { this.selectedItems = [data]; this.dialogs.changestatus = true; }
      else if (type === "upgrade_validity") { this.selectedItems = [data]; this.dialogs.changevalidity = true; }
      else if (type === "receiver_info") this.fetchTransferInfo(data.id);
    },

    copyids(t) {
      if (!t) return;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(t).then(() => this.$toast.success("شناسه کپی شد."));
      }
    },

        fetcDataInFolder(foldername, page = 1, length = 10) {
      this.$set(this.folderLoadings, foldername, true);

      let param = {
        folder_name: foldername,
        search: this.tableProps.search,
        length: length,
        column: "created_at",
        dir: this.tableProps.dir,
        page: page,
      };
      if (this.tableProps.type !== 'all') param.type = this.tableProps.type;
      if (this.tableProps.status !== 'all') param.status = this.tableProps.status;

      this.$api
        .get("v1/pre_purchase", { params: param })
        .then((res) => {
          // ذخیره کل آبجکت پجینیشن سرور
          const responseData = res.data.data || res.data || [];
          this.$set(this.folderItemsMap, foldername, responseData);

          if (this.activeFolderGroup && (this.activeFolderGroup.key === foldername || this.activeFolderGroup.folder_name === foldername)) {
            this.activeFolderGroup.items = responseData;
          }
        })
        .catch(({ response }) => {
          this.$modal.error("خطا", response?.data?.message || "مشکلی در دریافت فایل‌های پوشه رخ داد.");
        })
        .finally(() => {
          this.$set(this.folderLoadings, foldername, false);
        });
    },

    fetchList() {
      this.loading = true;
      let param = {
        search: this.tableProps.search,
        length: this.tableProps.length,
        column: "created_at",
        dir: this.tableProps.dir,
        page: this.tableProps.page,
      };
      if (this.tableProps.type !== 'all') param.type = this.tableProps.type;
      if (this.tableProps.status !== 'all') param.status = this.tableProps.status;

      this.$api
        .get("v1/pre_purchase/folders", { params: param })
        .then((res) => {
          this.transactionData = res.data.data || res.data;
          if (this.transactionData.current_page) {
            this.tableProps.page = this.transactionData.current_page;
          }
        })
        .catch(({ response }) => {
          this.$modal.error("خطا", response?.data?.message || "مشکلی در دریافت لیست رخ داد.");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onPhoneInput(number) {
      if (!number) {
        this.transferForm.phone = "";
        return;
      }
      let engNum = number;
      const p = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
      const a = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
      for (let i = 0; i < 10; i++) {
        engNum = engNum.replace(p[i], i).replace(a[i], i);
      }
      this.transferForm.phone = engNum;
    },

    cleanPhone(phone) {
      if (!phone) return "";
      let cleaned = phone.toString().replace(/[^\d]/g, "");
      if (cleaned.startsWith("09")) cleaned = "98" + cleaned.substring(1);
      return cleaned;
    },

    onPhoneValidate({ number, valid, country }) {
      if (number !== undefined && valid !== undefined && country !== undefined) {
        this.phoneValidated = { number, valid, country };
      }
    },

    fetchTransferInfo(uuid) {
      this.dialogs.info = true;
      this.transferInfoData = null;
      this.infoLoading = true;
      this.$api
        .get(`v1/pre_purchase/transfer-info/${uuid}`)
        .then((res) => {
          this.transferInfoData = res.data.data;
        })
        .finally(() => {
          this.infoLoading = false;
        });
    },

    exportData(targetIds = null, groupKey = null) {
      let idsToExport = [];
      if (Array.isArray(targetIds) && targetIds.length > 0) {
        idsToExport = targetIds;
      } else if (this.selectedItems.length > 0) {
        idsToExport = this.selectedItems.map(item => item.id);
      }

      if (groupKey) this.downloadingGroupKey = groupKey;
      else this.loadingExport = true;

      const payload = {};
      if (idsToExport.length > 0) payload.ids = idsToExport;
      if (groupKey) payload.folder_name = groupKey;

      this.$api
        .post("v1/pre_purchase/export", payload)
        .then((res) => {
          if (res.data?.link) {
            const link = document.createElement("a");
            link.href = res.data.link;
            link.setAttribute("download", "");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(({ response }) => {
          this.$modal.error("خطا", response?.data?.message || "مشکلی در دریافت فایل خروجی رخ داد.");
        })
        .finally(() => {
          this.loadingExport = false;
          this.downloadingGroupKey = null;
        });
    },
  },
};
</script>

<style scoped>
.custom-link-chip {
  background-color: #f5f7fa !important;
  border: 1px solid #e4e7eb;
}
.phone-input {
  direction: ltr !important;
}
.phone-input >>> .vti__dropdown {
  border-right: 1px solid #ccc;
  border-radius: 8px 0 0 8px;
}
.phone-input >>> .vti__input {
  border-radius: 0 8px 8px 0;
  height: 40px;
  font-size: 14px;
}
::v-deep .row-hide-checkbox .v-data-table__checkbox,
::v-deep .row-hide-checkbox .v-simple-checkbox {
  visibility: hidden !important;
  pointer-events: none !important;
}
</style>
